<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-button
      v-if="sageIntegration.active && !sageIntegration.inventory"
      variant="primary"
      v-on:click="updateSage()"
      class="btn btn-label btn-primary mb-4"
      ><i class="bx bx-check-circle label-icon"></i>Enable</b-button
    >
    <!-- Users -->
    <div class="row">
      <div class="col-lg-12">
        <div
          class="card"
          :class="!sageIntegration.inventory ? 'comingSoon' : ''"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="card-title">
                  <h5 class="float-left">Inventory (read only)</h5>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-8">
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="formItemsPerPage"
                          size="sm"
                          :options="formItemsPageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="formItemsFilter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    :items="formItemsTableData"
                    :fields="formItemsFields"
                    responsive="sm"
                    :per-page="formItemsPerPage"
                    :current-page="formItemsCurrentPage"
                    :sort-by.sync="formItemsSortBy"
                    :sort-desc.sync="formItemsSortDesc"
                    :filter="formItemsFilter"
                    :filter-included-fields="formItemsFilterOn"
                  >
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-right"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="formItemsCurrentPage"
                          :total-rows="formItemsTotalRows"
                          :per-page="formItemsPerPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!--/Row-->
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Vue from 'vue';
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from '@/app.config';
import routes from '../../../routes.js';

import firebase from 'firebase';
import axios from 'axios';
import Swal from 'sweetalert2';
import VueToast from 'vue-toast-notification';
// Import one of the available themes
import 'vue-toast-notification/dist/theme-sugar.css';

import { updateSageIntegrationDetails } from '../helper/dbHelpers';
import { parseBoolFromString } from '../helper/helpers';
import { customStateMethods } from '@/state/helpers';

Vue.use(VueToast);

export default {
  page: {
    title: 'Inventory',
    meta: [{ name: 'Inventory', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: 'Inventory',
      name: 'Inventory',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'inventory',
          href: '/production/inventory',
          active: true,
        },
      ],
      routes: routes,
      formItemsPerPage: 10,
      formItemsTotalRows: 1,
      formItemsCurrentPage: 1,
      formItemsPageOptions: [10, 25, 50, 100],
      formItemsFilter: null,
      formItemsFilterOn: [],
      formItemsSortBy: 'order',
      formItemsSortDesc: false,
      formItemsFields: [
        { key: 'category', sortable: true },
        { key: 'name', sortable: true },
        { key: 'description', sortable: true },
        { key: 'notes', sortable: true },
        { key: 'quantity', sortable: true },
      ],
      formItemsTableData: [],
      timeOutCounter: 0,
      procurements: [],
    };
  },
  methods: {
    ...customStateMethods,
    getInventoryReport: function() {
      if (this.timeOutCounter <= 3) {
        let sendParams = {
          access_token: `${sessionStorage.getItem('sage_access_token')}`,
          refresh_token: `${sessionStorage.getItem('sage_refresh_token')}`,
          org: sessionStorage.getItem('org'),
        };
        console.log;
        axios
          .get(
            `http://localhost:5000/kali-45420/us-central1/getSageInventory`,
            {
              //axios.get(`https://us-central1-kali-45420.cloudfunctions.net/getSageInventory`, {
              params: {
                sendParams,
              },
            }
          )
          .then((response) => {
            console.log(response);
            let inventoryData = response.data.items;
            // console.log(inventoryData.$items)
            inventoryData.forEach((item) => {
              this.formItemsTableData.push({
                category: item.location,
                name: item.item_code,
                description: item.description,
                notes: item.notesm,
                quantity: item.quantity_in_stock,
              });
            });
            console.log(inventoryData);
          })
          .catch((err) => {
            //check to see if the status code is 500. If it is, try to retrieve the updated tokens from the db.
            console.log(err.response);
            if (
              err.response.status == 500 &&
              err.response.data.response == 'Token expired'
            ) {
              //refresh the token.
              let sendParams = {
                refresh_token: `${sessionStorage.getItem(
                  'sage_refresh_token'
                )}`,
                org: sessionStorage.getItem('org'),
              };
              axios
                .get(
                  `http://localhost:5000/kali-45420/us-central1/refreshSageToken`,
                  {
                    //axios.get(`https://us-central1-kali-45420.cloudfunctions.net/refreshSageToken`, {
                    params: {
                      sendParams,
                    },
                  }
                )
                .then(async (response) => {
                  let success = await updateSageIntegrationDetails(
                    response.data.response.access_token,
                    response.data.response.refresh_token,
                    this.$store.state.custom.sageIntegration.invoicing,
                    this.$store.state.custom.sageIntegration.customers,
                    this.$store.state.custom.sageIntegration.inventory
                  );
                  if (success) {
                    this.getInventoryReport();
                  } else {
                    console.log('error updating sage integration details.');
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              console.log(`Error getting the inventory report`);
              Swal.fire(
                'Error!',
                'Error getting the inventory report.',
                'error'
              );
            }
          });
      }
    },
    updateSage: function() {
      Swal.fire({
        title: 'Enable inventory integration for Sage?',
        text:
          'The inventyory data will be read-only in kali and will not affect your inventory within Sage',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          //update the sage integration to have inventory active.
          //update the state and the db.
          firebase
            .firestore()
            .collection('organizations')
            .doc(sessionStorage.getItem('org'))
            .collection('integrations')
            .get()
            .then((querySnapshot) => {
              let id;
              querySnapshot.forEach((doc) => {
                //update the doc if it is the sage integration.
                id = doc.id;
              });
              return id;
            })
            .then((id) => {
              //update the document.
              firebase
                .firestore()
                .collection('organizations')
                .doc(sessionStorage.getItem('org'))
                .collection('integrations')
                .doc(id)
                .update({
                  sage: {
                    active: true,
                    invoicing: parseBoolFromString(
                      sessionStorage.getItem('sage_invoicing')
                    ),
                    customers: parseBoolFromString(
                      sessionStorage.getItem('sage_customers')
                    ),
                    inventory: true,
                    access_token: sessionStorage.getItem('sage_access_token'),
                    refresh_token: sessionStorage.getItem('sage_refresh_token'),
                  },
                })
                .then(() => {
                  try {
                    //update the sage integration details.
                    this.updateSageStatus({
                      sageStatus: {
                        active: true,
                        invoicing: parseBoolFromString(
                          sessionStorage.getItem('sage_invoicing')
                        ),
                        customers: parseBoolFromString(
                          sessionStorage.getItem('sage_customers')
                        ),
                        inventory: true,
                      },
                    });
                    this.sageIntegration.inventory = true;
                    Swal.fire(
                      'Success!',
                      'Sage integration successfully configured.',
                      'success'
                    );
                  } catch (err) {
                    console.log(err);
                    Swal.fire(
                      'Error!',
                      'Error configuring Sage integration.',
                      'error'
                    );
                  }
                })
                .catch((err) => {
                  console.log(err);
                  Swal.fire(
                    'Error!',
                    'Error configuring Sage integration.',
                    'error'
                  );
                });
            })
            .catch((err) => {
              console.log(err);
              Swal.fire(
                'Error!',
                'Error configuring Sage integration.',
                'error'
              );
            });
        }
      });
    },
  },
  computed: {
    sageIntegration: function() {
      return {
        active: parseBoolFromString(sessionStorage.getItem('sage_active')),
        inventory: parseBoolFromString(
          sessionStorage.getItem('sage_inventory')
        ),
      };
    },
  },
  mounted() {
    //get the access key from the db.
    //don't get the report if inventory is not enabled in the integration
    if (this.sageIntegration.inventory) {
      this.getInventoryReport();
    }
  },
};
</script>
